import styled from 'styled-components';
import color from '../../configs/color';
import boxShadow from '../../configs/boxShadow';

const Wrapper = styled.div`
  border: 1px solid ${color.grey2};
  box-shadow: ${boxShadow.normal};
  border-radius: 12px;
  background: ${color.grey5};
  width: 210px;
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 10;
  overflow: hidden;
`;

export default Wrapper;

export const SubButton = styled.div`
  color: ${color.black2};
  padding: 20px 17px;
  cursor: pointer;

  .anticon {
    margin-right: 13.6px;
  }

  &:hover {
    background: ${color.grey4};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${color.grey2};
  }
`;
